module.exports = __webpack_public_path__ + "static/IBA-HD_Logo-7f03b79bca4a2d5b00055d495dfaccc7.png";